import { useState } from "react";
import { useTranslation } from "react-i18next";

import InviteUser from "../InviteUser";

export const Toolbar = ({ onInvite }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation()

  return (
    <>
      <div className='toolbar reseller-toolbar' id='kt_toolbar'>
        <div id='kt_toolbar_container' className='container-fluid d-flex flex-stack reseller-toolbar__container'>
          <div className="reseller-toolbar__copy">
            <span className="reseller-toolbar__eyebrow">{t("reseller:toolbar.eyebrow")}</span>
            <h1 className="reseller-toolbar__title">{t("reseller:toolbar.title")}</h1>
          </div>
          <button
            onClick={() => setOpen(true)}
            className='btn btn-sm btn-primary cursor-pointer reseller-toolbar__button'
            id='kt_toolbar_primary_button'
          >
            {t("reseller:toolbar.buttons.invite")}
          </button>
        </div>
      </div>
      <InviteUser onInvite={onInvite} open={open} setOpen={setOpen} />
    </>
  );
};
